<template>
  <v-container>
    <v-navigation-drawer
      disable-resize-watcher
      v-model="drawerRight"
      fixed
      right
      width="350"
      class="pa-6"
    >
      <div>
        <h3>
          {{$t('company_data')}}
          <span class="float-right">
            <v-btn icon @click="isEdit = true" v-if="isAdmin">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon @click="closeDrawer">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </span>
        </h3>
      </div>

      <v-list dense>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-content>
              <span class="subtitle-1">ID</span>
            </v-list-item-content>
            <v-row no-gutters>
              <v-col md="12" class="ma-0">
                <v-text-field :label="$t('company_id')" v-model="editingData.id" outlined disabled></v-text-field>
              </v-col>
            </v-row>
            <v-list-item-content>
              <span class="subtitle-1">{{$t('name')}}</span>
            </v-list-item-content>
            <v-row no-gutters>
              <v-col md="12" class="ma-0">
                <v-text-field
                  :label="$t('company_name')"
                  v-model="editingData.name_company"
                  outlined
                  :disabled="!isEdit"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-list-item-content>
              <span class="subtitle-1">{{$t('location')}}</span>
            </v-list-item-content>
            <v-row no-gutters>
              <v-col md="6" class="ma-0">
                <v-text-field
                  :label="$t('latitude')"
                  v-model="editingData.lat_company"
                  outlined
                  :disabled="!isEdit"
                ></v-text-field>
              </v-col>
              <v-col md="6" class="ma-0">
                <v-text-field
                  :label="$t('longitude')"
                  v-model="editingData.lng_company"
                  outlined
                  :disabled="!isEdit"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col md="12" class="ma-0">
                <v-textarea
                  :label="$t('address')"
                  v-model="editingData.address_company"
                  outlined
                  :disabled="!isEdit"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-list-item-content>
              <span class="subtitle-1">{{$t('nav_setting')}}</span>
            </v-list-item-content>
            <v-row no-gutters>
              <v-col md="6" class="ma-0">
                <v-text-field
                  :label="$t('cutoff_date')"
                  v-model="editingData.cutoff_date"
                  outlined
                  type="number"
                  :disabled="!isEdit"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="isEdit">
              <v-col md="6">
                <v-btn block text @click="closeDrawer">{{$t('close')}}</v-btn>
              </v-col>
              <v-col md="6">
                <v-btn
                  block
                  depressed
                  color="primary"
                  :loading="updateLoading"
                  @click="updateCompanyData(editingData)"
                >{{$t('save')}}</v-btn>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-container fluid v-show="drawerLoading">
        <v-row align="center" justify="center" style="height: 500px;">
          <v-progress-circular :size="80" color="primary" indeterminate></v-progress-circular>
        </v-row>
      </v-container>
    </v-navigation-drawer>
  </v-container>
</template>
<script>
import axios from "axios";
export default {
  name: "company-data",
  data() {
    return {
      baseUrl: this.$store.state.baseUrl,
      isAdmin: false,
      isEdit: false,
      loading: false,
      dialog: false,
      drawerRight: false,
      drawerLoading: false,
      updateLoading: false,
      companies: [],
      editingData: {}
    };
  },
  methods: {
    async getCompanies() {
      this.loading = true;
      const result = await this.$store.state.companyDetail
      this.companies = result
      this.loading = false;
    },
    showDrawer(company) {
      this.editingData = company;
    },
    closeDrawer() {
      this.isEdit = false
      this.$store.dispatch("companyDrawer", false);
    },
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', { type, msg })
    },
    updateCompanyData(company) {
      this.updateLoading = true;
      const url = `${this.baseUrl}/company/edit`
      axios
        .post(url, {
          id_company: company.id,
          name_company: company.name_company,
          lat_company: company.lat_company,
          lng_company: company.lng_company,
          address_company: company.address_company,
          cutoff_date: company.cutoff_date
        }, { headers: { action: 'Edit Company', actionId: 2 } })
        .then(() => {
          this.updateLoading = false;
          this.closeDrawer()
          this.getCompanies();
          this.showMessage('success', 'Data Saved Successfuly')
        })
        .catch(err => {
          this.showMessage('error', 'Save Failed!')
          // eslint-disable-next-line no-console
          console.error(err);
        });
    }
  },
  created() {
    this.getCompanies();
    let role = this.$store.state.role;
    if (role == 0 || role == 2) {
      this.isAdmin = true
    }
  },
  computed: {
    openDrawer() {
      return this.$store.state.companyDrawer;
    }
  },
  watch: {
    openDrawer(newValue) {
      this.drawerRight = newValue
      if (newValue == true) {
        this.showDrawer(this.companies)
      } else {
        this.closeDrawer()
      }
    }
  }

};
</script>
